import { createSelector } from '@reduxjs/toolkit';
import { selectWithLayout } from 'shared/selectors/jsonQuery';

export const selectWithLayoutFilter = createSelector(selectWithLayout, value => ({
  label: 'Схема планировки',
  value: Boolean(value),
}));
